var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PostControllerLandingPage = /** @class */ (function () {
    function PostControllerLandingPage() {
    }
    /*****************************************************************************************************
        * Is using route "api/post/BriefingPost" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {File} smallMedia
        * @param {BriefingPostUploadDto} data
        * @returns {BriefingPostDownloadDto}
    ******************************************************************************************************/
    PostControllerLandingPage.PostBriefingBinaryAsync = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        if (data.smallMedia)
            fd.append("smallMedia", data.smallMedia);
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/BriefingPost", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/NewsPost" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {NewsPostUploadDto} data
        * @returns {NewsPostDownloadDto}
    ******************************************************************************************************/
    PostControllerLandingPage.PostNewsBinaryAsync = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/NewsPost", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/ContentPost" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {ContentPostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {ContentPostDownloadDto}
    ******************************************************************************************************/
    PostControllerLandingPage.PostContentBinaryAsync = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/ContentPost", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}/ContentPost/{lng}/trie" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} lng
        * @returns {ExtendedDataCollection<PostDownloadDto, Node<string>>}
    ******************************************************************************************************/
    PostControllerLandingPage.GetByTypeWithTire = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}/ContentPost/{lng}/trie", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/BriefingPost/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {File} smallMedia
        * @param {BriefingPostUploadDto} data
        * @returns {BriefingPostDownloadDto}
    ******************************************************************************************************/
    PostControllerLandingPage.PostBriefingPostBinaryAsync = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        if (data.smallMedia)
            fd.append("smallMedia", data.smallMedia);
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/BriefingPost/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/NewsPost/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {NewsPostUploadDto} data
        * @returns {NewsPostDownloadDto}
    ******************************************************************************************************/
    PostControllerLandingPage.PostNewsPostBinaryAsync = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/NewsPost/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/ContentPost/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {ContentPostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {BriefingPostDownloadDto}
    ******************************************************************************************************/
    PostControllerLandingPage.PostContentPostBinaryAsync = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/ContentPost/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/content/postStats" and http method "POST" to call the back-end.
    
        * @param {ContentPostFilterDto} filter
        * @returns {GroupStatDto[]}
    ******************************************************************************************************/
    PostControllerLandingPage.GetContentPostStatistics = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/content/postStats", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/content/postHistoryStats" and http method "POST" to call the back-end.
    
        * @param {ContentPostFilterDto} filter
        * @returns {PostTimeStatDataDto[]}
    ******************************************************************************************************/
    PostControllerLandingPage.GetContentPostHistoryStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/content/postHistoryStats", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/content/categoryClicks" and http method "POST" to call the back-end.
    
        * @param {EventFilterDto} filter
        * @returns {CategoryStatDto[]}
    ******************************************************************************************************/
    PostControllerLandingPage.GetCategoryClicks = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/content/categoryClicks", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/content/linkClickTypeStats" and http method "POST" to call the back-end.
    
        * @param {EventFilterDto} filter
        * @returns {GroupStatDto[]}
    ******************************************************************************************************/
    PostControllerLandingPage.GetLinkClickTypeStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/content/linkClickTypeStats", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/content/searchNotFoundStats" and http method "POST" to call the back-end.
    
        * @param {EventFilterDto} filter
        * @returns {GroupStatDto[]}
    ******************************************************************************************************/
    PostControllerLandingPage.GetSearchNotFoundStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/content/searchNotFoundStats", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/content/searchTermStats" and http method "POST" to call the back-end.
    
        * @param {EventFilterDto} filter
        * @returns {GroupStatDto[]}
    ******************************************************************************************************/
    PostControllerLandingPage.GetSearchTermStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/content/searchTermStats", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    return PostControllerLandingPage;
}());
export { PostControllerLandingPage };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostControllerLandingPage.js.map